import { UncachedRequest } from './base/uncachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new UncachedRequest()

export async function apiGetUserId() {
  return instance.get(endpoint.getUserId)
}
